

import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundImage: 'url("/image.avif")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    padding: '20px',
    width: '100%',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'
  },
  form: {
    background: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    padding: '2.5rem',
    borderRadius: '15px',
    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)',
    width: '100%',
    maxWidth: '450px'
  },
  logo: {
    display: 'block',
    width: '150px',
    margin: '0 auto 1.5rem',
  },
  inputContainer: {
    position: 'relative',
    marginBottom: '1.2rem',
  },
  input: {
    width: '100%',
    padding: '15px',
    paddingLeft: '45px',
    paddingRight: '45px',
    border: 'none',
    borderRadius: '8px',
    background: 'rgba(255, 255, 255, 0.8)',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    fontSize: '1rem',
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '10px',
    transform: 'translateY(-50%)',
    fontSize: '1.2rem',
    color: 'black',
  },
  toggleBtn: {
    position: 'absolute',
    top: '50%',
    right: '10px',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.2rem',
    color: 'black',
  },
  button: {
    width: '100%',
    padding: '15px',
    background: 'linear-gradient(to right,rgb(0, 0, 0),rgb(0, 0, 0))',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  title: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    color: '#2d3748',
    fontSize: '1.8rem',
  },
  link: {
    display: 'block',
    textAlign: 'center',
    marginTop: '1.2rem',
    color: '#000',
    textDecoration: 'none',
    fontSize: '1rem',
    fontWeight: '600',
  },
};

const RegisterPage = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    admin_pin: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
const handleSubmit = async e => {
  e.preventDefault();
  try {
    const response = await axios.post('https://gce.iasoft.ma/api/register', form);
    alert(response.data.message);
    navigate('/login');
  } catch (error) {
    alert(error.response?.data?.message || "Erreur lors de l'inscription");
  }
};

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <img src="/logo.png" alt="Logo" style={styles.logo} />
        <h2 style={styles.title}>Créer un compte</h2>

        <div style={styles.inputContainer}>
          <i className="fa fa-user" style={styles.icon}></i>
          <input
            type="text"
            name="name"
            placeholder="Nom"
            required
            style={styles.input}
            onChange={handleChange}
          />
        </div>

        <div style={styles.inputContainer}>
          <i className="fa fa-envelope" style={styles.icon}></i>
          <input
            type="email"
            name="email"
            placeholder="Email"
            required
            style={styles.input}
            onChange={handleChange}
          />
        </div>

        <div style={styles.inputContainer}>
          <i className="fa fa-key" style={styles.icon}></i>
        
               <input
        type="number"
        name="admin_pin"
        placeholder="Admin PIN"
        value={form.admin_pin}  style={styles.input}
        onChange={handleChange}
      />
        </div>

        <div style={styles.inputContainer}>
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Mot de passe"
            required
            style={styles.input}
            onChange={handleChange}
          />
          <button
            type="button"
            style={styles.toggleBtn}
            onClick={() => setShowPassword(!showPassword)}
          >
            <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
          </button>
        </div>

        <div style={styles.inputContainer}>
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            name="password_confirmation"
            placeholder="Confirmer mot de passe"
            required
            style={styles.input}
            onChange={handleChange}
          />
          <button
            type="button"
            style={styles.toggleBtn}
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            <i className={`fa ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
          </button>
        </div>

        <button type="submit" style={styles.button}>S'inscrire</button>
        <Link to="/login" style={styles.link}>Déjà un compte?</Link>
      </form>
    </div>
  );
};

export default RegisterPage;
